// src/components/pages/RegistrationPage.js
// 등록 폼 제거 - 추후 SyncAI 기반 다국어 지원/협업/XR 체험 등록 기능이 들어올 자리를
// "Coming Soon" 안내로 대체. 폼이 준비되면 이 파일에 다시 form을 추가하면 됩니다.
import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import HeroBanner from '../common/HeroBanner';

const RegistrationPage = () => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* 메인 이미지 - 자르지 않고 원본 그대로, 텍스트 오버레이 없음 */}
      <HeroBanner image="/images/registration.png" overlay={false} />

      {/* 검은 배경 안내 블록 - 등록 폼 대신 Coming Soon */}
      <Box
        sx={{
          backgroundColor: '#0f172a',
          color: 'white',
          p: { xs: 4, md: 6 },
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
          Registration
        </Typography>

        <Typography
          variant="body1"
          sx={{ color: '#D1D5DB', lineHeight: 1.8, maxWidth: '100%', mx: 'auto', mb: 3 }}
        >
          AI 기반의 SyncAI 솔루션을 활용한 다국어 지원, 실시간 협업, XR 체험까지,
          <br />
          향후 다양한 기능을 직접 등록하고 미리 경험해보실 수 있는 페이지가 준비될 예정입니다.
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Chip
            label="Coming Soon"
            sx={{
              backgroundColor: '#16a34a',
              color: 'white',
              fontWeight: 'bold',
              fontSize: '0.85rem',
              px: 1.5,
              py: 2.5
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default RegistrationPage;
